import { connect } from "react-redux";

import api from "api";
import PasswordReset from "components/PasswordReset";
import {
  authSuccess,
  changeForm,
  setErrors,
  init,
  openDialog
} from "redux/modules/passwordReset";
import { openErrorDialog } from "redux/modules/errorDialog";
import history from "utils/history";

const mapStateToProps = state => {
  return { ...state.passwordReset };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  checkResetToken: resetToken => {
    const params = {
      resetToken
    };

    api
      .get("password/new", params)
      .then(() => {
        dispatch(authSuccess());
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeForm: (key, value) => {
    dispatch(changeForm(key, value));
  },
  handleSubmit: (password, passwordConfirmation) => {
    const params = {
      resetToken: ownProps.match.params.reset_token,
      password,
      passwordConfirmation
    };

    api
      .post("password", params)
      .then(res => {
        if (res.errors) {
          dispatch(setErrors(res.errors));
        } else {
          dispatch(init());
          dispatch(openDialog());
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  historyPush: path => history.push(path, ownProps)
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);



// WEBPACK FOOTER //
// ./src/containers/PasswordResetContainer.js